// This file maps Microsoft Entra ID (Azure AD) group names to dashboard configuration sections
// Replace these example names with your actual MSAL group names

// Default fallback group mappings
const DEFAULT_USER_GROUP = 'user';
const DEFAULT_ADMIN_GROUP = 'admin';

// Example MSAL group names (replace with your actual group names)
export const msalGroupMapping: Record<string, string> = {
  // Example: Azure AD Group for Skyway Range users -> maps to 'skyway' in dashboardConfig
  'TechHubSAFET-SkywayRange-Exec-AD': 'Skyway Range',
  'TechHubSAFET-DronePort-AD': 'DronePort Network',
  'TechHubASWP-SA-Atlas-AD': 'Atlas',
  'TechHubASWP-SA-Asemio-AD': 'Asemio',
  'TechHubASWP-SA-TCC-AD': 'TCC',
  'TechHubASWP-SA-THEC-AD': 'THEC',
  'TechHubASWP-SA-TU-AD': 'TU - ASWP',
  'TechHubASWP-SA-inTulsa-AD': 'inTulsa - ASWP',
  'TechHubARCH-SA-OSU-AD': 'OSU',
  'TechHubARCH-SA-TU-AD': 'TU - ARCH',
  'TechHubCT-SA-InTulsa-AD': 'inTulsa - CNTRL',
  'TechHubGACE-SA-BlackTechStreet-AD': 'Black Tech Street',
  'TEchHubSAFET-SA-TU-AD': 'TU - SAFE-T'
};

/**
 * Maps an MSAL group name to a dashboard configuration key
 * 
 * @param msalGroupName The MSAL group name from the token
 * @param isAdmin Whether the user has admin role
 * @returns The corresponding dashboard configuration key
 */
export function mapMsalGroupToDashboardGroup(msalGroupName: string, isAdmin: boolean = false): string {
  // First check if we have a direct mapping for this group name
  if (msalGroupName in msalGroupMapping) {
    return msalGroupMapping[msalGroupName];
  }
  
  // If no specific mapping exists, use default based on admin status
  return isAdmin ? DEFAULT_ADMIN_GROUP : DEFAULT_USER_GROUP;
}

/**
 * Maps a user's groups to a dashboard configuration key
 * 
 * @param groups Array of MSAL group names
 * @param isAdmin Whether the user has admin role 
 * @returns The best matching dashboard configuration key
 */
export function getBestGroupMatch(groups: string[] = [], isAdmin: boolean = false): string {
  if (!groups || groups.length === 0) {
    return isAdmin ? DEFAULT_ADMIN_GROUP : DEFAULT_USER_GROUP;
  }
  
  // Try to find a match for each group in order
  for (const groupName of groups) {
    const mappedGroup = mapMsalGroupToDashboardGroup(groupName, isAdmin);
    if (mappedGroup) {
      return mappedGroup;
    }
  }
  
  // Fall back to default if no matches
  return isAdmin ? DEFAULT_ADMIN_GROUP : DEFAULT_USER_GROUP;
} 